import clsx from "clsx";
import { FC, useEffect, useRef } from "react";
import styles from "./C284_DonationTool_NonBlackbaud.module.scss";

type C284_DonationTool_NonBlackbaudContent = {
  donationIframeId: string;
  src: string;
};

export type Props = {
  content: C284_DonationTool_NonBlackbaudContent;
};

const C284_DonationTool_NonBlackbaud: FC<Props> = ({ content }) => {
  const { donationIframeId, src } = content;
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== "https://validaid.org") return;

      if (
        event.data?.type === "validaid-resize" &&
        event.data?.iframeId === donationIframeId
      ) {
        if (iframeRef.current) {
          iframeRef.current.style.height = `${event.data.height}px`;
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <div className={clsx("component", styles.C284_DonationTool_NonBlackbaud)}>
      <iframe
        ref={iframeRef}
        id={donationIframeId}
        src={src}
        title="Validaid Donation Form"
        style={{ width: "100%", border: "none" }}
        allow="payment"
      />
    </div>
  );
};

export default C284_DonationTool_NonBlackbaud;
